import styles from './Form.module.css';
import { Box, Stepper, Step, StepLabel } from '@mui/material';

const MyStepper = ({ activeTab, setSetActiveTab }) => {
  const steps = ['Step 1', 'Step 2', 'Create Vertical'];

  return (
    <div className={styles.row}>
      {activeTab === 1 && (
        <div>
          <button onClick={() => setSetActiveTab(0)} className={styles.backBtn}>
            {'< Back'}
          </button>
        </div>
      )}

      <div className={styles.stepWrapper}>
        <Box sx={{ width: '100%' }}>
          <Stepper activeStep={activeTab} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
      </div>
    </div>
  );
};

export default MyStepper;
